import createIcon from '../../createIcon';

/**
 * @component @name TableRestaurant
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjEuOTYwMSA5LjczTDIwLjUzMDEgNC43M0MyMC40MTAxIDQuMyAyMC4wMjAxIDQgMTkuNTcwMSA0SDQuNDMwMDlDMy45ODAwOSA0IDMuNTkwMDkgNC4zIDMuNDcwMDkgNC43M0wyLjA0MDA5IDkuNzNDMS44NjAwOSAxMC4zNiAyLjM0MDA5IDExIDMuMDAwMDkgMTFINS4yMDAwOUw0LjAwMDA5IDIwSDYuMDAwMDlMNi42NzAwOSAxNUgxNy4zNDAxTDE4LjAwMDEgMjBIMjAuMDAwMUwxOC44MDAxIDExSDIxLjAwMDFDMjEuNjYwMSAxMSAyMi4xNDAxIDEwLjM2IDIxLjk2MDEgOS43M1pNNi45MzAwOSAxM0w3LjIwMDA5IDExSDE2LjgwMDFMMTcuMDcwMSAxM0g2LjkzMDA5WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const TableRestaurant = createIcon('TableRestaurant', [
  [
    'path',
    {
      d: 'M21.9601 9.73L20.5301 4.73C20.4101 4.3 20.0201 4 19.5701 4H4.43009C3.98009 4 3.59009 4.3 3.47009 4.73L2.04009 9.73C1.86009 10.36 2.34009 11 3.00009 11H5.20009L4.00009 20H6.00009L6.67009 15H17.3401L18.0001 20H20.0001L18.8001 11H21.0001C21.6601 11 22.1401 10.36 21.9601 9.73ZM6.93009 13L7.20009 11H16.8001L17.0701 13H6.93009Z',
      key: '1wl3iw',
    },
  ],
]);

export default TableRestaurant;
